"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const Button_1 = require("@Components/Buttons/Button");
const rightsholderUser_1 = require("@App/api/routes/rightsholder/rightsholderUser");
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const EditActionsGroupsTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/UserPermissionsModal/ChangePermissionPopup/EditActionsGroupsTable"));
const ChangePermissionPopup = (props) => {
    const params = (0, react_router_dom_1.useParams)();
    const { popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { myUserGroups, setRightsholderUser, setUsersGroup, getUsersForUser, onCancelEdit, onCloseConfirmPopup, editActionsGroups, rightsholderUser, } = props;
    const onConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        const rightsHolderId = Number(params.rightsholderId);
        const userId = params.userId;
        if (!userId) {
            throw new Error('no user id');
        }
        const groups = myUserGroups
            .filter((item) => item.checked)
            .map((item) => ({
            name: item.name,
        }));
        try {
            const rightsholder = yield (0, rightsholderUser_1.editRightsholderUser)(rightsHolderId, userId, groups);
            setRightsholderUser(rightsholder.data);
            setUsersGroup(rightsholder.data);
            yield getUsersForUser(rightsholder.data);
            onCloseConfirmPopup();
            onCancelEdit(rightsholder.data);
            popupStore.setAlertData('User permissions have been updated.', false);
        }
        catch (error) {
            popupStore.setAlertFromError(error);
        }
    });
    return (react_1.default.createElement("div", { className: 'edit-permissions-popup-content' },
        react_1.default.createElement("h3", null, "Want to confirm the permission changes?"),
        react_1.default.createElement("p", null, "You are updating a user's permissions. Changing a user's permissions will impact the activities they can perform in this account. Do you want to continue?"),
        react_1.default.createElement(EditActionsGroupsTable_1.default, { editActionsGroups: editActionsGroups, rightsholderUser: rightsholderUser }),
        react_1.default.createElement("div", { className: 'buttons' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: onCloseConfirmPopup }, "Cancel"),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: onConfirm }, "Confirm"))));
};
exports.default = (0, mobx_react_1.observer)(ChangePermissionPopup);
